export default "__VITE_ASSET__vb$Pfvr1__"